import { types } from "../types/types";

const initialState = {
  catalogRegion: {},
  catalogRegions: [],
  catalogRegionsP: [],
  catalogRegionsS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
};
export const catalogRegionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REGION_SELECT:
      return {
        ...state,
        catalogRegion: action.payload,
      };

    case types.REGION_UPDATE:
      if (state.catalogRegionsS.length > 0) {
        return {
          ...state,
          catalogRegionsS: state.catalogRegionsS.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
          catalogRegionsP: state.catalogRegionsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      } else {
        return {
          ...state,
          catalogRegionsP: state.catalogRegionsP.map((usr) => (usr.id === action.payload.id ? action.payload : usr)),
        };
      }

    case types.REGION_DELETE:
      if (state.catalogRegionsS.length > 0) {
        return {
          ...state,
          catalogRegionsS: state.catalogRegionsS.filter((usr) => usr.id !== action.payload),
          catalogRegionsP: state.catalogRegionsP.filter((usr) => usr.id !== action.payload),
          catalogRegion: {},
        };
      } else {
        return {
          ...state,
          catalogRegionsP: state.catalogRegionsP.filter((usr) => usr.id !== action.payload),
          catalogRegion: {},
        };
      }

    case types.REGION_START_LOADING:
      //console.log("--->JT, Reducer catalogRegions, action.payload", action.payload);
      return {
        ...state,
        catalogRegions: action.payload,
      };

    case types.REGION_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogRegionsP: action.payload.regionsP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.REGION_START_SEARCH:
      return {
        ...state,
        catalogRegionsS: action.payload,
      };

    case types.REGION_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogRegionsS: action.payload.regionsP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.REGION_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogRegionsS: [],
      };

    case types.REGION_CLEAN:
      return {
        ...state,
        catalogRegion: {},
      };

    case types.REGION_START_REGISTER:
      return {
        ...state,
        catalogRegion: action.payload,
      };

    case types.REGION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    default:
      return state;
  }
};
